"use client";

import { pagesPath } from "@/utils/pages-path";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

function RedirectTo({ url }: { url: string }) {
  const router = useRouter();
  useEffect(() => {
    router.push(url);
  }, [router, url]);
  return <div />;
}

export function MemberRedirectToMfa() {
  return <RedirectTo url={pagesPath.members.mfa.$url().path} />;
}

export function EmployerRedirectToMfa() {
  return <RedirectTo url={pagesPath.employers.mfa.$url().path} />;
}
